import { createI18n } from 'vue-i18n';
import en from '@/locales/en.json';
import pt from '@/locales/pt.json';

const url = new URL(window.location.href);
const lang = url.searchParams.get('lang');

let locale: string;

if (lang) {
    locale = lang;
} else {
    locale = window.localStorage.getItem('locale') || 'en';
}

const i18n = createI18n({
    // Disable legacy API:
    legacy: false, // you must set `false`, to use Composition API
    // If you still want `<template>{{ $t('msg') }}</template>` to work:
    globalInjection: true,
    fallbackLocale: 'en',
    locale: locale,
    numberFormats: {
        en: {
            currency: {
                style: 'currency',
                currency: 'EUR',
            },
            money: {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
            moneyNoCents: {
                style: 'decimal',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            },
        },
        pt: {
            currency: {
                style: 'currency',
                currency: 'BRL',
            },
            money: {
                style: 'decimal',
                useGrouping: false, // Disable grouping separator
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
            moneyNoCents: {
                style: 'decimal',
                useGrouping: false, // Disable grouping separator
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            },
        },
    },
    messages: {
        en,
        pt,
    },
});

export default i18n;
